import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "options", "onChange", "error", "errorMessage", "multiple", "required", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Autocomplete, autocompleteClasses, TextField } from '@mui/material';
import * as Eq from 'fp-ts/Eq';
import { constant, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as RA from 'fp-ts/ReadonlyArray';
import { Controller } from 'react-hook-form';
import { Translation } from 'react-i18next';
import { getErrorMessage } from './form-helpers';
import { jsx as _jsx } from "react/jsx-runtime";

var getAutocompleteOptionEq = function getAutocompleteOptionEq() {
  return pipe(Eq.eqStrict, // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  Eq.contramap(function (x) {
    return x.value;
  }));
};

var AutocompleteFormField = function AutocompleteFormField(_ref) {
  var label = _ref.label,
      options = _ref.options,
      _onChange = _ref.onChange,
      error = _ref.error,
      errorMessage = _ref.errorMessage,
      multiple = _ref.multiple,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? RA.isEmpty(options) : _ref$disabled,
      controllerProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Controller, _objectSpread(_objectSpread({}, controllerProps), {}, {
    rules: _objectSpread(_objectSpread({}, controllerProps.rules), {}, {
      required: required
    }),
    render: function render(_ref2) {
      var field = _ref2.field;
      return /*#__PURE__*/_jsx(Translation, {
        children: function children(t) {
          return /*#__PURE__*/_jsx(Autocomplete, _objectSpread(_objectSpread({}, field), {}, {
            multiple: multiple,
            sx: _defineProperty({}, "& .".concat(autocompleteClasses.popupIndicator), {
              color: function color(t) {
                return t.palette.text.secondary;
              }
            }),
            getOptionLabel: function getOptionLabel(option) {
              return pipe(options, RA.findFirst(function (o) {
                return o.value === option;
              }), O.match(function () {
                return '';
              }, function (o) {
                return o.label;
              }));
            },
            disabled: disabled,
            options: pipe(options, RA.uniq(getAutocompleteOptionEq()), // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            RA.map(function (o) {
              return o.value;
            })),
            noOptionsText: t('No options'),
            size: "small",
            openText: t('Open'),
            closeText: t('Close'),
            clearText: t('Clear'),
            renderInput: function renderInput(params) {
              return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
                required: required,
                error: !!error,
                helperText: error && t(getErrorMessage(error, errorMessage)),
                FormHelperTextProps: {
                  sx: {
                    ml: 0
                  }
                }
              }, params), {}, {
                label: label,
                onChange: function onChange(e) {
                  return pipe(options, RA.findFirst(function (o) {
                    return o.value === e.target.value;
                  }), O.match(constant(''), function () {
                    return field.onChange(e.target.value);
                  }));
                },
                InputLabelProps: {
                  shrink: true
                }
              }));
            },
            onChange: function onChange(ev, newValue) {
              field.onChange(newValue);
              if (_onChange) _onChange(newValue, ev);
            }
          }));
        }
      });
    },
    "data-element": "Controller",
    "data-component": "AutocompleteFormField",
    "data-source-file": "autocomplete-form-field.tsx"
  }));
};

export default AutocompleteFormField;